const seo = {
    title: 'PlaY',
    description: 'Play the Y board game with other players or with AI.',
};

export {
    seo,
};
